// ABOUTME: Route for /library/$documentId/markdown.
// ABOUTME: Renders the DocumentMarkdown component showing raw markdown content of a document.

import DocumentMarkdown from "@/components/DocumentMarkdown";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/library/$documentId/markdown",
)({
  component: DocumentMarkdown,
});
